import { ActionMethod, AssetType, CardType } from '../../api/models/Shared.types';
import { Backend } from '../../api/Backend';
import { ChannelModel } from '../../api/EpgApi.types';
import { Log } from '@lightningjs/sdk';
import { IFavoriteElementV1, IRibbon2Asset, IRibbon2Container } from '../../api/models/AndromeTV.types';

/**
 * @enum {string}
 */
export const FavoriteRequestType = {
  CHANNEL: 'CHANNEL',
  CHANNEL_LOGO: 'CHANNEL_LOGO',
  CHANNEL_TOGGLE: 'CHANNEL_TOGGLE',
  VOD: 'VOD',
  EPG: 'EPG',
  EPG_FUTURE: 'EPG_FUTURE',
  EPG_PAST: 'EPG_PAST',
};

export interface customFavObj extends IRibbon2Asset {
  channelNumber: number;
}

export class FavoriteRibbonRequest {
  private channels: ChannelModel[];
  private backend: Backend;
  private requestType: string;

  constructor(backend: Backend, favoriteRequestType: string, channels: ChannelModel[]) {
    Log.info('[FavoriteRibbonRequest]', favoriteRequestType);
    this.channels = channels;
    this.backend = backend;
    this.requestType = favoriteRequestType;
  }

  load(): Promise<IRibbon2Container> {
    return this.backend.cachedFavoriteApi.list(this.backend, false).then(data => {
      const favorites = this._filterFavorites(data);
      const catalogId = this.backend.deviceProfile?.profile.catalog;
      const result: IRibbon2Container = { type: '' };
      result.type = this.requestType === FavoriteRequestType.VOD ? CardType.Portrait : CardType.Landscape;
      result.nextPage = false;
      result.items = favorites
        .map(fav => {
          const channel = this.channels.find(x => x.channelId === fav.id);
          let catalog;
          let image = '';
          if (channel) {
            catalog = channel.catalogs?.find(cat => cat.catalogId === catalogId);
            image = channel.image.posterLogo
              ? channel.image.posterLogo
              : channel.image.defaultLogo
              ? channel.image.defaultLogo
              : '';
          }
          const method =
            this.requestType === FavoriteRequestType.CHANNEL_LOGO ? ActionMethod.JUMP_TO_LIST : ActionMethod.FAVOURITE;
          const res: customFavObj = {
            method: method,
            channelNumber: catalog ? catalog.channelNumber : 999,
            channels: [],
            resources: [],
            asset: {
              type: fav.type,
              subType: this.requestType,
              id: fav.id,
              title: channel ? `${catalog ? catalog.channelNumber : 999} • ${channel.text.title}` : '',
              adult: fav.adult,
              image: image,
            },
          };
          return res;
        })
        .sort((a, b) => a.channelNumber - b.channelNumber);
      return result;
    });
  }

  _filterFavorites(data: IFavoriteElementV1[]): IFavoriteElementV1[] {
    const types = this._assetTypes();
    return data.filter(x => {
      if (types) {
        return types.includes(x.type as AssetType) && !x.adult;
      }
      return false;
    });
  }

  _assetTypes(): string[] {
    switch (this.requestType) {
      case FavoriteRequestType.CHANNEL:
      case FavoriteRequestType.CHANNEL_LOGO:
      case FavoriteRequestType.CHANNEL_TOGGLE:
        return [AssetType.CHANNEL];
      case FavoriteRequestType.VOD:
        return [AssetType.VOD];
      case FavoriteRequestType.EPG:
      case FavoriteRequestType.EPG_PAST:
      case FavoriteRequestType.EPG_FUTURE:
        return [AssetType.PROGRAM];
    }
    return [];
  }
}
